// extracted by mini-css-extract-plugin
module.exports = {"color":"Chart_color__MsjYs","wrapper":"Chart_wrapper__29a9P"};